<template lang="pug">
.room-name-example
  .d-flex.flex-row.align-items-center.flex-wrap
    .d-flex.flex-row.align-items-center(v-if="_facility.recruitmentRoom.multiBed")
      .room-name.multi-bed.mr-2.p-1 従多
      span.mr-2 従来型多床室
    .d-flex.flex-row.align-items-center(v-if="_facility.recruitmentRoom.conventinalSingle")
      .room-name.conventinal-single.mr-2.p-1 従個
      span.mr-2 従来型個室
    .d-flex.flex-row.align-items-center(v-if="_facility.recruitmentRoom.unitTypeSingle")
      .room-name.unit-type-single.mr-2.p-1 ユ個
      span.mr-2 ユニット型個室
    .d-flex.flex-row.align-items-center(v-if="_facility.recruitmentRoom.single")
      .room-name.single.mr-2.p-1 個室
      span.mr-2 個室
    .d-flex.flex-row.align-items-center(v-if="_facility.recruitmentRoom.double")
      .room-name.double.mr-2.p-1 ２人
      span.mr-2 ２人部屋（夫婦部屋）
    .custom-room-names.d-flex.flex-row.align-items-center(v-if="_facility.customRecruitmentRoom && 0 < _facility.customRecruitmentRoom.length"
      v-for="(room, index) in _facility.customRecruitmentRoom")
      .d-flex.flex-row.align-items-center(v-if="room.use")
        .room-name.mr-2.p-1(:style="`background: ${room.color};`") {{ room.abbreviationName }}
        span.mr-2 {{ room.name }}
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";
import { FacilityGetModel } from "@/commons/services/Facilities";

/**
 * ### 部屋種類凡例コンポーネント
 */
@Component({})
export default class RoomNameExample extends Vue {
  get _facility(): FacilityGetModel {
    return userStore.getFacility;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.room-name-example {
  .room-name {
    width: 39px;
    min-width: 34px;
    font-size: 12px;
    border: solid 1px $border-darkgray;
    text-align: center;
  }
  .multi-bed {
    background: #ecd8be;
  }
  .conventinal-single,
  .unit-type-single,
  .single {
    background: #e8f3f5;
  }
  .double {
    background: #93bafa;
  }
}
</style>
